import { render } from "./DetailsService.vue?vue&type=template&id=856176aa&scoped=true"
import script from "./DetailsService.vue?vue&type=script&lang=js"
export * from "./DetailsService.vue?vue&type=script&lang=js"

import "./DetailsService.vue?vue&type=style&index=0&id=856176aa&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856176aa"],['__file',"resources/js/pages/services/DetailsService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "856176aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('856176aa', __exports__)) {
    console.log('reload')
    api.reload('856176aa', __exports__)
  }
  
  module.hot.accept("./DetailsService.vue?vue&type=template&id=856176aa&scoped=true", () => {
    console.log('re-render')
    api.rerender('856176aa', render)
  })

}


export default __exports__